import { useMutation } from 'react-query';
import { httpService } from '../../../services/http.service';
import { BASE_URL } from '../../../constants/endpoints';
import { useStore } from '../../../store';

interface IProps {
    amount: number;
    direction: boolean;
}

export const useMoveBucketMoney = ({ amount, direction }: IProps) => {
  const { customerId } = useStore(state => state.user);
  return useMutation(
    'useAddAmountToBucket',
    async () => {
      const res = await httpService.post(
        `${BASE_URL}/api/v1/user/${customerId}/bucket/emergency/move`,
        {
          amount,
          pullFromBucket: direction,
        },
      );
      return res.data;
    },
    {},
  );
};
